import { RootState } from "@base/store";
import { WithAnalytics } from "@base/utils/hoc/withSendPageAnalytics";
import { ProfilePhoto } from "@components/organisms/profilePhoto";
import { SignUp } from "@components/organisms/signUp";
import React, { useEffect, useState } from "react";
import { ConnectedProps, connect, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { homeActions } from "../home/home.slice";

type ReduxProps = ConnectedProps<typeof connector>;

const Register = ({ setUser }: ReduxProps) => {
  const navigate = useNavigate();

  const user = useSelector((state: RootState) => state.user.user);

  const [contentRender, setContentRender] = useState({
    signUp: false,
    setProfilePhoto: false,
  });

  const isUserInfilled = () => {
    if (user?.firstName && user?.lastName && user?.dob) {
      return true;
    } else {
      return false;
    }
  };

  const isAnyStateTrue = () => {
    return Object.values(contentRender).some((value) => value === true);
  };

  const authStatus = () => {
    if (!isUserInfilled()) {
      setContentRender({
        setProfilePhoto: false,
        signUp: true,
      });
    }
  };

  useEffect(() => {
    if (user.email) {
      authStatus();
    }
  }, [user]);

  return (
    <>
      {isAnyStateTrue() && contentRender.signUp ? (
        <SignUp authState={authStatus} setContentRender={setContentRender} />
      ) : (
        <ProfilePhoto
          authState={authStatus}
          onSkip={() => {
            navigate("/home");
          }}
        />
      )}
    </>
  );
};

const mapDispatchToProps = {
  setUser: homeActions.setUser,
};

const connector = connect(undefined, mapDispatchToProps);
const RegisterRedux = connector(WithAnalytics(Register));

export { RegisterRedux as Register };
